import { api } from '@setplex/tria-api'
import { attach, createEvent } from 'effector'

export const getToa = createEvent()

export const getToaFx = attach({ effect: api.session.getToaFx })
